/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Status of the Project whether it is Active or Closed.
 *
 */
export var ProjectStatus;
(function (ProjectStatus) {
    ProjectStatus["ACTIVE"] = "ACTIVE";
    ProjectStatus["CLOSED"] = "CLOSED";
    ProjectStatus["PENDING"] = "PENDING";
})(ProjectStatus || (ProjectStatus = {}));
